(() => {
  if (customElements.get('salamander-header-motion')) return;

  customElements.define('salamander-header-motion', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section');
      this.marker = this.querySelector('.st-header-switch-point');
      if (!this.section || !this.marker) return;
      this.desktop = matchMedia('(min-width: 1000px)');
      this.abort = new AbortController();
      this.configure = this.configure.bind(this);
      const options = { signal: this.abort.signal };
      this.desktop.addEventListener('change', this.configure, options);
      window.addEventListener('resize', this.configure, options);
      window.addEventListener('pageshow', this.configure, options);
      this.announcement = document.querySelector('.shopify-section--announcement-bar');
      if (this.announcement) {
        this.resize = new ResizeObserver(this.configure);
        this.resize.observe(this.announcement);
      }
      this.configure();
    }

    configure() {
      if (!this.isConnected) return;
      if (!this.desktop.matches) {
        this.observer?.disconnect();
        this.observer = null;
        this.section.removeAttribute('data-st-motion');
        this.section.removeAttribute('data-st-compact');
        return;
      }
      const root = getComputedStyle(document.documentElement);
      const offset = (parseFloat(root.getPropertyValue('--announcement-bar-is-sticky')) || 0) *
        (parseFloat(root.getPropertyValue('--announcement-bar-height')) || 0);
      if (this.observer && this.offset === offset) return;
      this.offset = offset;
      this.observer?.disconnect();
      this.section.setAttribute('data-st-motion', 'switch');
      this.observer = new IntersectionObserver(entries => {
        const entry = entries[entries.length - 1];
        const compact = entry.boundingClientRect.top < (entry.rootBounds?.top ?? this.offset) &&
          entry.intersectionRatio < 0.05;
        if (this.section.hasAttribute('data-st-compact') !== compact) {
          this.section.toggleAttribute('data-st-compact', compact);
        }
      }, { rootMargin: `-${offset}px 0px 0px 0px`, threshold: 0.05 });
      this.observer.observe(this.marker);
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      this.observer?.disconnect();
      this.observer = null;
      this.section?.removeAttribute('data-st-motion');
      this.section?.removeAttribute('data-st-compact');
    }
  });
})();
